//
//
//
//
//
//
//
//
//
//

export default {
    name: "GoHome",
    data() {
        return {}
    },
    methods: {
        handleGoHome() {
            this.$router.push({
                name: 'Home'
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/subComponents/GoHome.vue